module.exports = __webpack_public_path__ + "img/c3.a3faaa0e.png";